import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGiftsActiveByCampaign } from 'redux/Reducers/Gift/GiftApi';
import { getParticipantGroup } from 'redux/Reducers/ParticipantGroup/ParticipantGroupApi';

const GiftPermissions = ({ children }) => {
  const { isLoaded } = useSelector(({ oidc }) => oidc);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoaded) {
      dispatch(getParticipantGroup());
      dispatch(getGiftsActiveByCampaign());
    }
  }, [isLoaded]);

  return <>{children}</>;
};

export default GiftPermissions;
